/**
 * Shared localStorage cache for Prometheus app state.
 * All features store data under the single `prometheus_cache` key,
 * namespaced by section (e.g. "onboarding", "bss_assessment").
 */

const LOCALSTORAGE_KEY = 'prometheus_cache';

export type PrometheusCache = Record<string, unknown>;

export function loadCache(): PrometheusCache {
  try {
    const saved = localStorage.getItem(LOCALSTORAGE_KEY);
    if (saved) return JSON.parse(saved);
  } catch (error) {
    console.error('[prometheus_cache] Failed to load:', error);
  }
  return {};
}

export function saveCache(cache: PrometheusCache): void {
  try {
    localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(cache));
  } catch (error) {
    console.error('[prometheus_cache] Failed to save:', error);
  }
}

/** Read a single section from the cache */
export function getCacheSection<T>(section: string): T | undefined {
  const cache = loadCache();
  return cache[section] as T | undefined;
}

/** Write a single section to the cache (merges with existing) */
export function setCacheSection(section: string, data: unknown): void {
  const cache = loadCache();
  cache[section] = data;
  saveCache(cache);
}

/** Remove a single section from the cache */
export function clearCacheSection(section: string): void {
  const cache = loadCache();
  delete cache[section];
  saveCache(cache);
}
